export default "__VITE_ASSET__CAmfbb95__"